'use strict';

var React = require('react');
require('../../theme/breakpoints.js');
require('imask');
var useMaybeControlledValue = require('../../hooks/useMaybeControlledValue.js');
require('resize-observer-polyfill');
var component = require('../Portal/component.js');
var useTooltip = require('./useTooltip.js');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const Tooltip = React.forwardRef(({ target, placement, children, isOpened: isOpenedFromProps, onOpenedChange: onOpenedChangeFromProps, ...props }, ref) => {
    const [tooltipElement, setTooltipElement] = React.useState(null);
    React.useImperativeHandle(ref, () => tooltipElement);
    const [isOpened, onOpenedChange, { isControlled }] = useMaybeControlledValue.useMaybeControlledValue({
        valueFromProps: isOpenedFromProps,
        onChangeFromProps: onOpenedChangeFromProps,
        defaultValue: false,
    });
    const tooltip = useTooltip.useTooltip({
        isControlled,
        isOpened,
        onOpenedChange,
        placement,
        target,
        tooltip: tooltipElement,
    });
    return (React__default.default.createElement(component.Portal, null,
        React__default.default.createElement(styles.Styled.TooltipContainer, { ...props, style: { ...props.style, ...tooltip.style }, isOpened: isOpened, placement: placement, role: "tooltip", ref: setTooltipElement },
            React__default.default.createElement(styles.Styled.Tooltip, null, children))));
});

exports.Tooltip = Tooltip;
//# sourceMappingURL=component.js.map
